/*
 * Create-mode info banner for CreateEditIntakeView ("Build intake form" callout).
 *
 * SCSS → Tailwind mapping (ceiv-info-banner*):
 *   .ceiv-info-banner: bg:#fff / border:1px solid --border-card(#141E1F1A) / radius:8px / padding:16px 20px
 *     → bg-white border border-shade-10 rounded-large py-sp-2 px-[20px]
 *   .ceiv-info-banner-title: font-size:14px / font-weight:600 / color:--highlight(#178199) / margin:0 0 4px
 *     → text-size-3 font-semibold text-text-highlight m-0 mb-1
 *   .ceiv-info-banner-desc: font-size:14px / font-weight:400 / color:--text-medium / margin:0 / line-height:20px
 *     → text-size-3 font-normal text-text-light m-0 leading-5
 *
 * highlight token: text-text-highlight = DS token for --highlight / #178199 (matches the
 *   CreateNewIntakeFormQuestionsBuilder / BuilderOptionsBlock convention).
 * Arbitrary value: px-[20px] (20px, no DS token).
 */
export function IntakeInfoBanner() {
  return (
    <div className='rounded-large border border-shade-10 bg-white px-[20px] py-sp-2'>
      <p className='m-0 mb-1 text-size-3 font-semibold text-text-highlight'>Build intake form</p>
      <p className='m-0 text-size-3 font-normal leading-5 text-text-light'>
        Start by giving it a name, then add up to 30 questions. Choose from 7 question types — patients see them in the
        order you list them.
      </p>
    </div>
  )
}
